<template>
  <VueBaseDialog ref="VueBaseDialog" :dialogConfig="dialogConfig">
    <div @click.stop="onFullScreen" class="fullScreen-outer"><span>全屏</span></div>
    <!-- 文档预览 -->
    <div class="pdf-view" v-if="dialogConfig.type == 4">
      <div class="pdf-parent">
          <pdf  v-show="loadedRatio == 1"
            ref="pdf"
            :style="styleObject"
            :src="file_url"
            :page="pageNum"
            :rotate="pageRotate"
            @num-pages="pageTotalNum = $event"
            @link-clicked="pageNum = $event"
          >
          </pdf>
          <div v-show="loadedRatio == 1" class="change-group">
              <div class="change-btn prev" @click.stop="prePage"></div>
              <div class="change-btn next" @click.stop="nextPage"></div>
          </div>
          <div v-show="loadedRatio == 0" class="el-loading-spinner">
            <i class="el-icon-loading"></i>
            <p class="el-loading-text">加载中</p>
          </div>
      </div>

     <div v-show="loadedRatio == 1" class="option-group">
        <el-button size="mini" type="text" :disabled="pageNum == 1" icon="el-icon-arrow-left" @click.stop="prePage"></el-button>
        <span class="page-span">第{{ pageNum }}页，共{{ pageTotalNum }}页</span>
        <el-button size="mini" type="text" :disabled="pageNum == pageTotalNum" icon="el-icon-arrow-right" @click.stop="nextPage"></el-button>

        <!-- <el-button size="mini" type="text" icon="el-icon-minus" @click="scaleX" ></el-button>
        <div>{{scale}}%</div>
        <el-button size="mini" type="text" @click="scaleD" icon="el-icon-plus"></el-button> -->

        <!-- <el-button size="mini" @click.stop="AutoPdfPage" type="text" :icon="AutoPage ? 'el-icon-video-pause' : 'el-icon-video-play'"></el-button> -->
        
        <el-button size="mini" type="text" icon="el-icon-full-screen" class="full-btn" @click.stop="onFullScreen"><span>全屏</span></el-button>
        
        <!-- <el-button class="btn-def" @click.stop="clock">顺时针</el-button>
        <el-button class="btn-def" @click.stop="counterClock">逆时针</el-button> -->
      </div>
    </div>

    <div v-show="isfullscreen" ref="fullElem" class="fullParent">
        <pdf :src="file_url" :page="fullNum"
            @num-pages="fullTotalNum = $event"
            @link-clicked="fullNum = $event"></pdf>
      
        <div class="change-group">
          <div class="change-btn prev" @click="preFullPage"></div>
          <div class="change-btn next" @click="nexFulltPage"></div>
        </div>
    </div>

  </VueBaseDialog>
</template>
<script>
// vue-pdf和vue-fullscreen来实现 预览pdf和全屏预览功能  
// 安装vue-pdf后报错 Cannot read properties of undefined (reading 'catch')"的解决方法：
// 1、卸载之前安装的vue-pdf，npm uninstall vue-pdf;
// 2、安装指定版本的vue-pdf和pdfjs-dist：
// npm install pdfjs-dist@2.5.207
// npm install vue-pdf@4.2.0
import VueBaseDialog from "./VueBaseDialog";
import pdf from "vue-pdf";
import axios from 'axios';
axios.defaults.withCredentials = true;  //允许跨域携带cookies

export default {
  name: "PreviewPdf",
  components: {
    VueBaseDialog,
    pdf,
  },
  props: ["dialogConfig"],
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      //是否自动播放
      AutoPage: false,
      timer: null,
      AutoTime: 5,
      isFull: 0,
      isfullscreen: false,
      scale: 100,
      styleObject: {
        transition: 'transform 0.3s ease',
        margin: '0 auto'
      },
      fullNum: 1,
      fullTotalNum: 1,
      // 加载进度
      loadedRatio: 0,
      file_url: ''
    };
  },
  mounted() {
    if (process.env.NODE_ENV == 'production') {
      if(this.dialogConfig.path){
        this.requestPath()
      }
    } else {
      console.log(this.dialogConfig.path)
      this.loadedRatio = 1
      this.file_url =  this.dialogConfig.path
    }
  },
  beforeDestroy() {},
  methods: {
    requestPath(){
      let that = this
      that.loadedRatio = 0
      // 无论测试、正式线 api和预览域名均使用正式线地址
        axios({
          // url: that.services.XUEXI_API_SERVER + '/api/apps/material/download?url=' + path,
          url: 'https://xuexi-api.jiaoyu.cn/api/apps/material/download?url=' + that.dialogConfig.path,
          method: 'get',
          responseType: 'blob',
        }).then(res => {
            that.loadedRatio = 1
          if (res.status == 200 && res.data) {
            let file_url = that.getObjectURL(res.data)
            that.file_url = file_url
          } else {
            that.$errorMsg("文件预览失败")
          }
        }).catch(() => {
          that.loadedRatio = 1
        })
    },
    // 将返回的文件流转换为url
    getObjectURL (data) {
      var url = null
      if (window.createObjectURL !== undefined) { // basic
        url = window.createObjectURL(data)
      } else if (window.webkitURL !== undefined) { // webkit or chrome
        try {
          url = window.webkitURL.createObjectURL(data)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) { // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(data)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    //上一页
    prePage() {
      if(this.pageNum == 1){
        return
      }
      var p = this.pageNum;
      p = p > 1 ? p - 1 : this.pageTotalNum;
      this.pageNum = p;
    },
    // 下一页
    nextPage() {
      if(this.pageNum == this.pageTotalNum){
        return
      }
      var p = this.pageNum;
      p = p < this.pageTotalNum ? p + 1 : 1;
      this.pageNum = p;
    },

    // 全屏上一页
    preFullPage() {
      if(this.fullNum == 1){
        return
      }
      var p = this.fullNum;
      p = p > 1 ? p - 1 : this.fullTotalNum;
      this.fullNum = p;
    },
    // 全屏下一页
    nexFulltPage() {
      if(this.fullNum == this.fullTotalNum){
        return
      }
      var p = this.fullNum;
      p = p < this.fullTotalNum ? p + 1 : 1;
      this.fullNum = p;
    },

    //顺时针
    clock() {
      this.pageRotate += 90;
    },
    //逆时针
    counterClock() {
      this.pageRotate -= 90;
    },
    // 自动播放
    AutoPdfPage() {
      var AutoTime = this.AutoTime * 1000;
      this.AutoPage = this.AutoPage == true ? false : true;
      if (this.AutoPage == true) {
        this.$successMsg("自动播放启动 " + this.AutoTime + "S自动翻页",)
        this.timer = setInterval(() => {
          console.log(this.pageNum);
          if (this.pageNum == this.pageTotalNum) {
            this.pageNum = 1;
          } else {
            this.pageNum++;
          }
        }, AutoTime);
      } else {
        this.$successMsg("自动播放停止 ")

        clearInterval(this.timer);
      }
    },
    //放大
    scaleD() {
      if (this.scale == 180) {
          return;
      }
      this.scale += 10;
      // this.styleObject.transform = `scale(${this.scale/100})`;
      this.$set(this.styleObject, 'transform', `scale(${this.scale/100})`)
    },

    //缩小
    scaleX() {
      if (this.scale == 40) {
        return;
      }
      this.scale -= 10;
      // this.styleObject.transform = `scale(${this.scale/100})`;
      this.$set(this.styleObject, 'transform', `scale(${this.scale/100})`)

    },
    //全屏切换
    onFullScreen() {
      let that = this
      if (this.isfullscreen) {
          this.$fullscreen.exit(); //退出全屏
      } else {
          // 通过ref拿到具体的、希望全屏展示的元素
        let dom = this.$refs.fullElem; 
        //打开全屏
        that.$fullscreen.enter(dom, {
            wrap: false,
            callback: (f) => {
              that.isfullscreen = f;
            }
        });
      }
    }
  },
}
</script>

<style lang="less">
// 需要支持放大缩小结构样式 start
// .pdf-parent{
//   width: 1200px; 
//   height: 675px;
//   overflow: hidden;
//   overflow-y: auto;
// }
// .parent-inner {
//   position: relative;
//   min-width: 1195px; 
//   min-height: 675px;
// }
// .fullParent {
  // width: 100vw;
  // overflow: hidden;
  // overflow-y: auto;
  // height: 100vh;
  // position: relative;
// }
// .change-group {
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
// }
// 需要支持放大缩小结构样式 end
.fullScreen-outer {
  padding: 2px 10px;
  border-radius: 4px;
  background-color: #3a81ff;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  display: inline-block;
  position: absolute;
  top: 18px;
  right: 50px;
  cursor: pointer;
}
.pdf-parent{
  width: 1200px; 
  height: 675px;
  overflow: hidden;
  position: relative;
}
.fullParent {
  position: relative;
}
.change-btn {
  width: 45%;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 10;
  cursor: pointer;
}
.change-btn.prev {
  left: 0;
  // border: 1px solid red;
}
 .change-btn.next {
  right: 0;
  // border: 1px solid yellow;
}

.option-group {
  display: flex;
  align-items: center;
  justify-content: center;
}
.option-group .page-span {
  font-size: 13px; 
  color: #6D6B69;
  display: inline-block;
  margin: 0 10px;
}
.option-group .full-btn {
  padding: 0 10px;
  display: inline-block;
}
.option-group .full-btn span {
  font-size: 12px; 
  color: #6D6B69;
  display: inline-block;
  margin-left: 1px;
}
// 适配h5
@media screen and (max-width: 700px) {   
  .pdf-parent{
    width: 95vw; 
    height: 26vh;
  }
  .option-group .full-btn {
    display: none;
  }
  .fullScreen-outer {
    display: none;
  }
}
</style>